export default __webpack_public_path__ + "static/media/graphics-02.dcfc7128.png";